<template>
  <MenuComponent modulo="rendimientos" :menuInferior="menuInferior"/>
  <main class="items-center w-full px-4 py-4 mx-auto my-10 bg-white rounded-lg shadow-md sm:w-11/12">
    <router-view v-slot="{ Component }">
      <Suspense timeout="0">
        <template #default>
          <div class="container mx-auto">
            <component :is="Component"></component>
          </div>
        </template>
        <template #fallback>
          <div class="container mx-auto">
            <LoadingComponent></LoadingComponent>
          </div>
        </template>
      </Suspense>
    </router-view>
  </main>
</template>
<script>
import MenuComponent from "@/layouts/MenuComponent";
import LoadingComponent from "@/layouts/LoadingComponent";
import {ref} from 'vue';

/**
 Componente que muestra el menú de opciones del módulo de Rendimientos, junto con la vista principal del módulo
 @module MenuRendimientos
 @vue
 */
/**
 * Exporta el componente `MenuRendimientos`
 * @name MenuRendimientos
 * @property {String} name Nombre del componente.
 * @property {Object} components Componentes hijos del componente actual.
 * @property {Array} data Objeto que contiene los datos que maneja el componente actual.
 * @property {Array} data.menuInferior Contiene los elementos del menú inferior del módulo de Rendimientos.
 */
export default {
  name: "MenuRendimientos",
  components: {MenuComponent, LoadingComponent},
  setup() {
    /**
     * Carga el menú inferior con los elementos correspondientes según el rol del usuario.
     * @function cargarMenuInferior
     * @returns {Array} - Lista de objetos que representan los elementos del menú inferior.
     */

    const cargarMenuInferior = () => {
      const userStored = JSON.parse(localStorage.getItem("user"));
      const elementos = [];

      let idPadre = '';
      let newPermisos = userStored.permisosUsuariosEntities.concat(userStored.rol.permisosRolesEntities);

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso.menu
        if(dataMenu.name == 'MenuRendimientos'){
          idPadre = dataMenu.id
        }
      }

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso
    
        if(dataMenu.estado)
        {
          if(dataMenu.menu.menu_padre_id == idPadre && dataMenu.menu.estado)
          {
            const result = elementos.find(({ name }) => name === dataMenu.menu.name);
            if(!result){
              elementos.push({
                alias: dataMenu.menu.alias, 
                name:  dataMenu.menu.name,
                current: (dataMenu.menu.name == 'TasasEA') ? true : false   
              });
            }
          }
        }
      }

      // {alias: "Tasas E.A. bancarias", name: "TasasEA", current: true},
      //   {alias: "Extractos Bancarios", name: "ExtractosBancarios", current: false},
      //   {alias: "Información Rendimientos", name: "InformacionRendimientos", current: false},
      
      return elementos;
    };

    const menuInferior = ref(cargarMenuInferior());
    return {
      /**
       * Lista de elementos del menú inferior.
       * @memberof MenuParametros
       * @type {Array}
       */
      menuInferior: menuInferior
    };
  }
};
</script>